var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "battery",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M0-47.5H24v24H0Z",
    transform: "translate(0 47.5)",
    fill: "#f3be0e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(2.526 0.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M-4.329-22.263A.632.632,0,0,1-4.72-22.4a.632.632,0,0,1-.171-.785l4.4-8.553H-8.118a.631.631,0,0,1-.592-.411.632.632,0,0,1,.179-.7l13.9-12A.632.632,0,0,1,5.776-45a.629.629,0,0,1,.39.135.633.633,0,0,1,.172.786l-4.4,8.553H9.566a.631.631,0,0,1,.592.411.631.631,0,0,1-.179.7l-13.894,12a.631.631,0,0,1-.413.153",
    transform: "translate(8.75 45)",
    fill: "#f3be0e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.e68eae4b0491450b839ae7e797e9d2ef.svg";
export { ForwardRef as ReactComponent };